import { render, staticRenderFns } from "./ListReferrals.vue?vue&type=template&id=b817de46&scoped=true"
import script from "./ListReferrals.vue?vue&type=script&lang=js"
export * from "./ListReferrals.vue?vue&type=script&lang=js"
import style0 from "./ListReferrals.vue?vue&type=style&index=0&id=b817de46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b817de46",
  null
  
)

export default component.exports